module.exports = {"title":"DIVOT/PUTT Location","selectGolfClub":"Select a golf club.","month1":"1 Month","month3":"3 Months","month6":"6 Months","tooltip":"Combined statistics for the searched period.","selectType":"Select a type.","point":"Point"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/cr001.json
// module id = LkEQ
// module chunks = 2